/**
 * Useful when we need to catch and error from a promise but don't want to immediately await it
 */
export async function catchError<P>(promise: Promise<P>): Promise<P | undefined>;
export async function catchError<P, T>(promise: Promise<P>, defaultValue: T): Promise<P | T>;
export async function catchError<P, T>(promise: Promise<P>, defaultValue?: T): Promise<P | T | undefined> {
  try {
    return await promise;
  } catch (_e) {
    return defaultValue !== undefined ? defaultValue : undefined;
  }
}
